import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import OutsideClickComponent from '../../fragments/OutsideClickComponent'



import classes from './CustomSelect.module.css'
import { useUserTabEditPermissionDisabled, useCanEditArchived } from '../../../lib/usersPermissions'
import { isInsidePortalModal } from '../../../lib/overlayLayers'
// #### No colors for Multiple!!!!! 

export default function CustomSelectMultiple({name, label, optionsData, preSelectedValue, action, identifier, isDisabled, rebuild, hasRebuildEnabled, fixedDrawer = true, hasRemove, fallbackSelectedOption}) {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.type)

    const toFocus = useRef(null)
    const containerRef = useRef(null)
    const drawerRef = useRef(null)
    const [coordinates, setCoordinates] = useState({
        top: null,
        left: null,
        width: null
    })
    const [showDrawer, setShowDrawer] = useState(false)
    // const [selectedHidden, setSelectedHidden] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [selectedValue, setSelectedValue] = useState([]) //in multiple this is an array!!!!!
    const [selectedValueArray, setSelectedValueArray] = useState([]) // send forward only the values, not the whole items


    const [removeValuesFlag, setRemoveValuesFlag] = useState(0)

    const [options, setOptions] = useState(optionsData)

    function changeInputhandler(event) {
        if (!userPermissionDisabled) {
            setInputValue(event.target.value)
            const query = (event.target.value ?? '').toString().toLowerCase()
            let filteredOptions = optionsData.filter(item => item.label.toString().toLowerCase().includes(query))
            setOptions(filteredOptions)
        }
        

        
    }
    const updateFixedDrawerCoordinates = useCallback(() => {
        if (!containerRef.current) {
            return
        }
        const rect = containerRef.current.getBoundingClientRect()
        const left = rect.left
        const width = rect.width
        const top = rect.top
        const bottom = rect.bottom
        const windowHeight = window.innerHeight

        if (windowHeight - bottom < 300) {
            setCoordinates({
                bottom: windowHeight - top + 8,
                left,
                width,
                top: 'unset',
            })
        } else {
            setCoordinates({
                top: bottom + 4,
                left,
                width,
                bottom: undefined,
            })
        }
    }, [])

    function focusHandler() {
        if (!userPermissionDisabled) {
            setShowDrawer(true)
            if (fixedDrawer) {
                updateFixedDrawerCoordinates()
            }
        }
    }

    useLayoutEffect(() => {
        if (showDrawer && fixedDrawer) {
            updateFixedDrawerCoordinates()
        }
    }, [showDrawer, fixedDrawer, updateFixedDrawerCoordinates])
    const blurHandler = useCallback(() => {
        setShowDrawer(false)
        // setSelectedHidden(false)
        setOptions(optionsData) // clear the filters
    }, [optionsData])

    function setOptionHandler(item) {

        if (!userPermissionDisabled) {
            setInputValue('') //clear input
            // setSelectedHidden(false) //show the selected value
            setOptions(optionsData) // clear the filters

            if ( item == null) {
                setSelectedValue([])
                setSelectedValue([]) //in multiple this is an array!!!!!
                setSelectedValueArray([]) // send forward only the values, not the whole items
                setOptions(optionsData)
                setShowDrawer(false)
                if (action) {
                    action({
                        data: {
                            value: []
                        },
                        identifier: identifier,
                    })
                }

                return
            }


            let optionAllreadySelected = selectedValue?.find(val => val.value === item.value)

            

            if (optionAllreadySelected) { // remove the value
    
                setSelectedValue(selectedValue.filter((a => a.value !== item.value)))
                setSelectedValueArray(selectedValueArray.filter((a => a !== item.value)))

                if (action) {
                    action({
                        data: {
                            value: selectedValueArray.filter((a => a !== item.value))
                        },
                        identifier: identifier,
                        options: selectedValue.filter((a => a.value !== item.value))
                    })
                }
            } else {  
                // setSelectedValue(prevArr => prevArr = [...prevArr, item])
                setSelectedValue([...selectedValue, item])
                // setSelectedValueArray(prevArr => prevArr = [...prevArr, item.value])
                setSelectedValueArray([...selectedValueArray, item.value])

                if (action) {
                    action({
                        data: {
                            value: [...selectedValueArray, item.value]
                        },
                        identifier: identifier,
                        options: [...selectedValue, item]
                    })
                }
        
            }
        }  
        
        
        setRemoveValuesFlag(0)
    }

    function removeSingleSelected(item, event) {
        event?.stopPropagation?.()
        event?.preventDefault?.()
        if (userPermissionDisabled) {
            return
        }
        setInputValue('')
        setOptions(optionsData)
        const nextSelected = selectedValue.filter((a) => a.value != item.value)
        const nextValuesArr = selectedValueArray.filter((a) => a != item.value)
        setSelectedValue(nextSelected)
        setSelectedValueArray(nextValuesArr)
        setRemoveValuesFlag(0)
        if (action) {
            action({
                data: {
                    value: nextValuesArr,
                },
                identifier,
                options: nextSelected,
            })
        }
    }

    // function setOptionHandlerEffect(item) {
    //     setInputValue('') //clear input
    //     setSelectedValue(prevArr => prevArr = [...prevArr, item])

    //     setSelectedValueArray(prevArr => prevArr = [...prevArr, item.value])

    //     setShowDrawer(false) //close drawer
    //     // setSelectedHidden(false) //show the selected value
    //     setOptions(optionsData) // clear the filters
    // }

    const justToggledClosedByMouseDownRef = useRef(false)

    function focusSelectOnClickHandler() {
        if (userPermissionDisabled) return
        if (justToggledClosedByMouseDownRef.current) {
            justToggledClosedByMouseDownRef.current = false
            return
        }
        if (showDrawer) return
        setShowDrawer(true)
        if (fixedDrawer) {
            updateFixedDrawerCoordinates()
        }
        if (toFocus && toFocus.current) {
            toFocus.current.focus()
        }
    }

    function toggleOnMouseDownHandler(event) {
        if (userPermissionDisabled) return
        if (showDrawer) {
            event.preventDefault()
            justToggledClosedByMouseDownRef.current = true
            blurHandler()
            toFocus.current?.blur()
        }
    }

    function clearSelectionHandler() {
        if (!userPermissionDisabled) {
            setOptionHandler(null)
            setRemoveValuesFlag(prevState => prevState + 1)
            // setSelectedValue([])
            // setSelectedValue([]) //in multiple this is an array!!!!!
            // setSelectedValueArray([]) // send forward only the values, not the whole items
            // setOptions(optionsData)
            // setShowDrawer(false)
            // if (action) {
            //     action({
            //         data: {
            //             value: []
            //         },
            //         identifier: identifier,
            //     })
            // }
        }
    }

    useEffect(() => {
        if (optionsData && preSelectedValue && removeValuesFlag == 0) {
            let foundOptions = []
            for (let index = 0; index < preSelectedValue.length; index++) {
                // const element = array[index];
                let foundOption = optionsData.find(item => item.value == preSelectedValue[index])
                if (!foundOption && fallbackSelectedOption) {
                    try {
                        const fallback = fallbackSelectedOption(preSelectedValue[index])
                        if (fallback) {
                            foundOption = fallback
                        }
                    } catch {
                        // ignore fallback errors
                    }
                }
                if (foundOption) {
                    foundOptions.push(foundOption)
                }
                if (foundOptions) {
                    setSelectedValue(foundOptions)
                    setSelectedValueArray(foundOptions.map(item => item.value))
                    // setShowDrawer(false)
                }
        
                // old functionality 
                // if (foundOption) {
                //     const index = selectedValue.findIndex(object => {
                //         return object.value == foundOption.value
                //     })          


                //     if (index == -1) {
                //         setOptionHandlerEffect(foundOption)                

                //     }
                // }
                
            }  

            
        } else {
            setSelectedValue([])
            // setInputValue('')
            setSelectedValue([]) //in multiple this is an array!!!!!
            setSelectedValueArray([]) // send forward only the values, not the whole items
        }

    }, [optionsData, preSelectedValue, rebuild, removeValuesFlag, fallbackSelectedOption])

    useEffect(() => {
        if (optionsData) {
            setOptions(optionsData)   
        }        
    }, [optionsData])

    useEffect(() => {
        if (!showDrawer) {
            return
        }

        const onScrollOrResize = () => {
            if (fixedDrawer) {
                updateFixedDrawerCoordinates()
                return
            }
            blurHandler()
        }

        document.addEventListener('scroll', onScrollOrResize, true)
        window.addEventListener('resize', onScrollOrResize, { passive: true })
        return () => {
            document.removeEventListener('scroll', onScrollOrResize, true)
            window.removeEventListener('resize', onScrollOrResize)
        }
    }, [showDrawer, fixedDrawer, blurHandler, updateFixedDrawerCoordinates])
    
    const isOptionInactive = (item) => {
        const disabledRaw = item?.isDisabled
        return disabledRaw === true || disabledRaw === 1 || disabledRaw === '1'
    }

    const outsideClickExtraInsideRefs = useMemo(() => fixedDrawer ? [drawerRef] : undefined, [fixedDrawer])

    if (!optionsData) { // no options were sent
        return <div className={`${classes.container}`}>        
            <OutsideClickComponent task={blurHandler}>
                
                <div className={classes.input_container}>
                    {label && <span className={classes.label}>label</span>}
                    <input name={name} type='text' className={classes.input} autoComplete="off"/>
                    <div className={classes.selected}>No data available</div>
                    <div className={`${classes.pointer}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            </OutsideClickComponent>
        </div>
    }   

    const insideModal = fixedDrawer && isInsidePortalModal(containerRef.current)

    const drawerNode = showDrawer ? (
        <div
            ref={drawerRef}
            className={`${classes.drawer} ${fixedDrawer ? classes.fixed : ''} ${insideModal ? classes.fixed_above_modal : ''}`}
            style={{ top: coordinates.top, left: coordinates.left, width: coordinates.width, bottom: coordinates.bottom }}
        >
            {options && options.filter(item => !isOptionInactive(item)).map(item => (
                <div key={item.value}>
                    <button type='button' onClick={setOptionHandler.bind(this, item)} className={`${classes.option} ${(selectedValue && (selectedValue.find(val => val.value === item.value))) ? classes.option_selected : ''}`}>{item.label}</button>
                </div>
            ))}
        </div>
    ) : null

    const overlayRoot = typeof document !== 'undefined' ? document.getElementById('overlay-root') : null

    return <div className={`${classes.container} ${(showDrawer || (selectedValue && selectedValue.length > 0)) ? classes.is_focused : ''} ${classes.container_multiple} ${isDisabled || editArchivedDisabled || userPermissionDisabled ? classes.is_inactive : ''}`}>
        <OutsideClickComponent task={blurHandler} extraInsideRefs={outsideClickExtraInsideRefs}>
            
            <div ref={containerRef} className={`${classes.input_container} ${hasRemove ? classes.has_remove_button : ''}`} onMouseDown={toggleOnMouseDownHandler} onClick={focusSelectOnClickHandler}>
                {label && <div className={classes.label}>{label}</div>}
                
                <div className={`${classes.input_container_multiple}`}>

                    {selectedValue && selectedValue.length > 0 && <>
                        {selectedValue.map((item, chipIndex) => (
                            <span
                                key={`chip_${String(item.value ?? 'null')}_${chipIndex}`}
                                className={`${classes.selected_single_item} ${isOptionInactive(item) ? classes.chip_inactive : ''}`}
                            >
                                <span className={classes.chip_label}>
                                    {item.label}{isOptionInactive(item) ? ' (Inactive)' : ''}
                                </span>
                                <button
                                    type="button"
                                    className={classes.chip_remove_btn}
                                    title="Remove"
                                    aria-label={`Remove ${item.label}`}
                                    onClick={(e) => removeSingleSelected(item, e)}
                                >
                                    <i className="ti ti-x"></i>
                                </button>
                            </span>
                        ))}
                    </>}

                    <input ref={toFocus} name={name} type='text' onChange={changeInputhandler} onFocus={focusHandler} className={classes.input} value={inputValue} autoComplete="off"/>
                    {/* {selectedValue && selectedValue.length > 0 && <div className={classes.selected_container}>
                        {selectedValue.map(item => (
                            <div key={item.value + Math.random()} title='remove item' className={classes.selected_single_item}>{item.label}</div>
                        ))}    
                    </div>}

                    <input name={name} type='text' onChange={changeInputhandler} onFocus={focusHandler} className={classes.input} value={inputValue} autoComplete="off"/> */}
                </div>
                {hasRemove && <button type='button' className={`${classes.clear_select} custom_select_clear_button`} onClick={clearSelectionHandler}><i className='ti ti-x'></i></button>}
                <div className={`${classes.pointer} ${showDrawer && classes.opened}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>

            {fixedDrawer
                ? (drawerNode && overlayRoot && ReactDOM.createPortal(drawerNode, overlayRoot))
                : drawerNode}
        </OutsideClickComponent>
    </div>
}